/**
 * Canonical import report routes.
 *
 * Use these constants instead of hardcoded strings so the redirects in
 * App.tsx and the links in ChangelogPage always point to the same destination.
 *
 * Update the date when a new dataset + re-seed is generated.
 */

/** City import report. Last session: db:fresh + db:seed — 2026-05-11 */
export const REPORT_GEO_IMPORT_PATH = "/reports/geo-import/2026-05-11"

/** Route import report. */
export const REPORT_ROUTES_IMPORT_PATH = "/reports/routes-import"
